<template>
    <v-row class="my-4">
        <v-col>
            <v-text-field v-model="searchValue" prepend-inner-icon="mdi-magnify" rounded outlined class="rounded-0" @keydown.enter="search" />
        </v-col>
        <v-col cols="auto">
            <v-btn color="primary" class="rounded-0" @click="search">검색하기</v-btn>
        </v-col>
        <v-col cols="auto" class="pl-0">
            <v-btn color="secondary" class="rounded-0" @click="clickArea">분야선택</v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        value: String,
    },
    computed: {
        isOutSync() {
            return this.value !== this.searchValue;
        },
    },
    data() {
        return { searchValue: null };
    },
    methods: {
        init() {
            this.value = this.searchValue;
        },
        sync() {
            this.$emit("input", this.searchValue);
        },
        search() {
            this.$emit("search");
        },
        clickArea() {
            this.$emit("clickArea");
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            if (this.isOutSync) this.init();
        },
        searchValue() {
            if (this.isOutSync) this.sync();
        },
    },
};
</script>

<style></style>
